import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { EnumOrganizationType } from 'api-clients/identity-server-api-client';
import { MgaCarrierAccessCheckClient } from 'api-clients/rating-api-client';
import { BannerService } from 'src/shared/banners/banner.service';
import { UserService } from 'src/shared/user.service';

@Injectable()
export class CommercialLinesAuthGuard {
  readonly #router = inject(Router);
  readonly #userService = inject(UserService);
  readonly #mgaCarrierAccessCheckClient = inject(MgaCarrierAccessCheckClient);
  readonly #bannerService = inject(BannerService);

  async canActivate(): Promise<true | UrlTree> {
    try {
      const isMgaBranch = this.#userService.user.organizationType === EnumOrganizationType.MGABranch;
      const isCommercialRatingProductEnabled = isMgaBranch ? await this.#mgaCarrierAccessCheckClient.hasCarriersConfiguredByMGAAdmin()
        : this.#userService?.user?.products?.commercialRating;
      if (!isCommercialRatingProductEnabled) {
        return this.#router.createUrlTree(['errors', '403']);
      }
      return true;
    } catch {
      this.#bannerService.addError('There was an error while trying to get access for the Commercial Lines tab');
      return this.#router.createUrlTree(['errors', '403']);
    }
  }
}
